/**
 * RevenueCat IAP integration for Planbase
 *
 * API Key: appl_SDvDaNeRAMzSgFbUoIZCtyxEzhr (Apple)
 *
 * Product identifiers must match exactly what's configured in App Store Connect
 * and RevenueCat dashboard.
 */

import { Capacitor } from '@capacitor/core';

// ── Constants ─────────────────────────────────────────────────────────────────

export const RC_API_KEY_APPLE = 'appl_SDvDaNeRAMzSgFbUoIZCtyxEzhr';

/**
 * RevenueCat Entitlement identifiers — configure these in the RC dashboard.
 * An entitlement unlocks a tier regardless of which product was purchased.
 */
export const RC_ENTITLEMENTS = {
  PRO:        'pro',
  ENTERPRISE: 'enterprise',
} as const;

/**
 * Product identifiers — must match App Store Connect & RC product IDs.
 * Adjust these to match what you create in App Store Connect.
 */
export const RC_PRODUCTS = {
  PRO_MONTHLY:        'planbase_pro_monthly',
  PRO_ANNUAL:         'planbase_pro_annual',
  ENTERPRISE_MONTHLY: 'planbase_enterprise_monthly',
  ENTERPRISE_ANNUAL:  'planbase_enterprise_annual',
} as const;

export type RCEntitlement = typeof RC_ENTITLEMENTS[keyof typeof RC_ENTITLEMENTS];
export type RCProduct = typeof RC_PRODUCTS[keyof typeof RC_PRODUCTS];

export type PlanTier = 'free' | 'pro' | 'enterprise';

export interface PlanInfo {
  tier: PlanTier;
  isActive: boolean;
  expiresAt?: Date;
  willRenew?: boolean;
  productIdentifier?: string;
}

/** Returns true when running on a native platform where IAP is available */
export const isNativePlatform = () => Capacitor.isNativePlatform();

/** Map entitlement id → plan tier */
export const entitlementToTier = (entitlementId: string): PlanTier => {
  if (entitlementId === RC_ENTITLEMENTS.ENTERPRISE) return 'enterprise';
  if (entitlementId === RC_ENTITLEMENTS.PRO) return 'pro';
  return 'free';
};
